var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3H18C22.9688 3 27 7.03125 27 12C27 16.9688 22.9688 21 18 21H9C4.03125 21 0 16.9688 0 12C0 7.03125 4.03125 3 9 3ZM9 18C12.3188 18 15 15.3141 15 12C15 8.68125 12.3141 6 9 6C5.68125 6 3 8.68594 3 12C3 15.3188 5.68594 18 9 18Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOffIcon);
export default __webpack_public_path__ + "static/media/toggleOffIcon.902eb1463d171720ecc8017ac4fd2a08.svg";
export { ForwardRef as ReactComponent };